/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { StarredFromLocalStorage } from "./StarredFromLocalStorage";
import {
  StarredFromLocalStorageFromJSON,
  StarredFromLocalStorageFromJSONTyped,
  StarredFromLocalStorageToJSON,
  StarredFromLocalStorageToJSONTyped,
} from "./StarredFromLocalStorage";

/**
 *
 * @export
 * @interface ListOfStarredObjects
 */
export interface ListOfStarredObjects {
  /**
   *
   * @type {Array<StarredFromLocalStorage>}
   * @memberof ListOfStarredObjects
   */
  starredObjects: Array<StarredFromLocalStorage>;
}

/**
 * Check if a given object implements the ListOfStarredObjects interface.
 */
export function instanceOfListOfStarredObjects(
  value: object,
): value is ListOfStarredObjects {
  if (!("starredObjects" in value) || value["starredObjects"] === undefined)
    return false;
  return true;
}

export function ListOfStarredObjectsFromJSON(json: any): ListOfStarredObjects {
  return ListOfStarredObjectsFromJSONTyped(json, false);
}

export function ListOfStarredObjectsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ListOfStarredObjects {
  if (json == null) {
    return json;
  }
  return {
    starredObjects: (json["starredObjects"] as Array<any>).map(
      StarredFromLocalStorageFromJSON,
    ),
  };
}

export function ListOfStarredObjectsToJSON(json: any): ListOfStarredObjects {
  return ListOfStarredObjectsToJSONTyped(json, false);
}

export function ListOfStarredObjectsToJSONTyped(
  value?: ListOfStarredObjects | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    starredObjects: (value["starredObjects"] as Array<any>).map(
      StarredFromLocalStorageToJSON,
    ),
  };
}
